export const priceQuoteDataKeys: { [key: string]: string } = {
    franchiseWebLocationId: 'number',
    conceptId: 'number',
    serviceIdsAndQuantities: 'object',
    brandId: 'number',
    postalCode: 'number',
    includeDetail: 'boolean',
    serviceItems: 'object',
  };
  